
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { useReactToPrint } from "react-to-print";
import { useRef } from 'react';
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, IconButton } from '@mui/material';
import Logo from '../../assets/Logo.png'
import { httpGetAPI } from '../../api/api';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(() => ({
    LogoSize: {
        width: '30px !important',
        height: '45px !important'
    },
    dialog: {
        borderRadius: '25px !important',
        "& .embeddedDoc div, & .embeddedDoc span, & .embeddedDoc p, & .embeddedDoc *": {
            margin: "0px !important;",
            padding: "0px !important;",
            textAlign: "center !important",
            backgroundColor: "#f0f3f0"
        },
        "& .embeddedDoc img": {
            display: "none !important;"
        },
        "& .embeddedDoc span": {
            height: '0 !important;',
            width: '0 !important;'
        }
    },
    dialogTitle: {
        alignItems: 'center !important',
        display: "flex",
        flexDirection: "column"
    },
    dialogTitleText: {
        marginRight: '0.3rem !important',
        fontWeight: 'bold !important'
    },
    buttonFont1: {
        fontSize: '1rem !important',
        textTransform: "capitalize !important"
    },
    buttonGreen: {
        color: 'white !important',
        fontWeight: 'bold !important',
        backgroundColor: '#3a7735 !important',
        borderRadius: '2rem !important'
    },
    buttonRed: {
        color: 'red !important',
        fontWeight: 'bold !important',
        backgroundColor: 'white !important',
        border: '1px solid red !important',
        borderRadius: '2rem !important'
    },

    printIcon: {
        justifyContent: 'left !important',
        margin: '0.2rem !important',
        cursor: 'pointer !important'
    },
    print: {
        '@media print': {
            '.page-break': {
                marginTop: "1rem !important",
                display: "block !important",
                pageBreakBefore: "auto"
            }
        }
    }

}));
const TermsDialog = ({ openDialog, setOpenDialog, title, src, termsConfirms, showButtons = false, print = false, showApproveButton = false, needToAccp = false, exitButton = false }) => {
    const classes = useStyles()
    const componentRef = useRef();
    const { t } = useTranslation();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const getTermsDiv = async (ref) => {

        if (ref && ref.childElementCount === 0) {

            let d = document.createElement('div');
            d.style.backgroundColor = "#f0f3f0"
            d.classList.add("embeddedDoc"); // optional
            try {
                const res = await httpGetAPI(src);
                d.innerHTML = res.data;
            } catch (error) {
                d.innerHTML = error;
            }

            ref.appendChild(d);

        }

    }

    return (
        <Dialog
            className={classes.dialog}
            open={openDialog}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    setOpenDialog(false);
                }
            }}
            disableEscapeKeyDown={true}
            hideBackdrop={false}
            scroll={'paper'}
            PaperProps={{
                sx: { borderRadius: "40px !important", backgroundColor: "#f0f3f0" }
            }}
        >
            <DialogTitle>
                <Box className={classes.dialogTitle}>
                    <img
                        className={classes.LogoSize}
                        src={Logo}
                        alt='..'
                        loading="lazy"
                    />
                    <Typography className={classes.dialogTitleText}>{title}</Typography>
                    {needToAccp && <Typography className={classes.dialogTitleText}>{t("termsHasToBeAcc")}</Typography>}
                </Box>

            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
                    {exitButton && (
                        <IconButton onClick={() => setOpenDialog(false)}>
                            <CloseIcon sx={{ color: '#3a7735' }} />
                        </IconButton>
                    )}
                    {print && <Box display="flex" flexDirection="row" alignItems="center" className={classes.printIcon}>
                        <PrintIcon sx={{ color: '#3a7735' }} onClick={handlePrint} /></Box>}
                </Box>
                <DialogContentText className={`${classes.print}`} ref={componentRef} component="span">
                    <div ref={(r) => { getTermsDiv(r) }} dir="rtl" style={{ textAlign: "center" }} />
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center !important' }}>
                {showButtons &&
                    <Box display='flex' flexDirection='row' >
                        <Button className={`${classes.buttonGreen} ${classes.buttonFont1}`} sx={{ margin: "0.5rem" }} onClick={e => termsConfirms(true)}  >{t('agree')}</Button>
                        <Button className={`${classes.buttonRed} ${classes.buttonFont1}`} sx={{ margin: "0.5rem" }} onClick={e => termsConfirms(false)}> {t('disagree')}</Button>
                    </Box>}
                {showApproveButton &&
                    <Box display='flex' flexDirection='row' >
                        <Button className={`${classes.buttonGreen} ${classes.buttonFont1}`} sx={{ margin: "0.5rem" }} onClick={e => termsConfirms(true)}  >{t('agree')}</Button>
                    </Box>}
            </DialogActions>
        </Dialog>)
}
export default TermsDialog;